import { render, staticRenderFns } from "./BriqIsoDurationInput.vue?vue&type=template&id=3c4f4df9&scoped=true&lang=pug&"
import script from "./BriqIsoDurationInput.vue?vue&type=script&lang=js&"
export * from "./BriqIsoDurationInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqIsoDurationInput.vue?vue&type=style&index=0&id=3c4f4df9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f4df9",
  null
  
)

export default component.exports